import { useFormik } from "formik";
import { noop } from "lodash";
import { type CheckboxProps, Header, Icon, Radio } from "semantic-ui-react";
import ScheduleTypes from "../../../../../../enums/scheduleTypes";
import { type ScheduleConfiguration } from "../../types/models";
import { DateTimePicker } from "../../../../../../components/calendar/DateTimePicker";
import { useCallback } from "react";
import { TimezoneDropdown } from "features/Library/Common/Fields/timezone-dropdown/TimezoneDropdown";
import { type ScheduleProps } from "../../Details/types";
import styles from "./schedule.module.scss";

export const Schedule = (props: ScheduleProps) => {
  const { useTimeZone, configuration, onScheduleChange } = props;

  const formik = useFormik<Partial<ScheduleConfiguration>>({
    initialValues: configuration,
    onSubmit: noop,
  });

  const onTimeZoneChange = async (propertyName: string, value: string, shouldValidate?: boolean) => {
    const { setFieldValue } = formik;

    await setFieldValue(propertyName, value, shouldValidate);
    onScheduleChange((prev) => ({ ...prev, timeZone: value }));
  };

  const onChange = useCallback(
    (_: any, data: CheckboxProps) => {
      onScheduleChange((prev) => ({ ...prev, type: data.value as ScheduleTypes }));
    },
    [onScheduleChange],
  );

  const setSelectedDate = useCallback(
    (newDateString: string, newTimeString: string) => {
      onScheduleChange((prev) => ({ ...prev, date: newDateString, time: newTimeString }));
    },
    [onScheduleChange],
  );

  return (
    <>
      <div className={styles.scheduleContainer}>
        <Header className={styles.header}>Delivery Schedule</Header>
        <div className={styles.radio}>
          <Radio
            className={styles["radio-btn"]}
            label="Send Now"
            name="radioGroup"
            value={ScheduleTypes.SendNow}
            checked={configuration.type === ScheduleTypes.SendNow}
            onChange={onChange}
          />
          <span>Email will be sent immediately.</span>
        </div>
        <div className={styles.radio}>
          <Radio
            className={styles["radio-btn"]}
            label="Send On"
            name="radioGroup"
            value={ScheduleTypes.SendOn}
            checked={configuration.type === ScheduleTypes.SendOn}
            onChange={onChange}
          />
          <span>Email will be sent on the scheduled date.</span>
        </div>
        {configuration.type === ScheduleTypes.SendOn && (
          <div className={styles.scheduleConfiguration}>
            <DateTimePicker dateValue={configuration.date} timeValue={configuration.time} onChange={setSelectedDate} />
            {useTimeZone && (
              <TimezoneDropdown
                propertyName={"scheduleTimeZone"}
                setFieldTouched={formik.setFieldTouched}
                setFieldValue={onTimeZoneChange}
                value={configuration.timeZone as string}
                icon={<Icon className="fa-clock" />}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
};
